<template>
    <div :class="['dropdown_a', v && v.$error ? 'is-error' : '' ]">
        <v-autocomplete
                class="autocomplete"
                :class="theme"
                :items="currentList"
                @change="changeHandler"
                :placeholder="placeholder"
                :no-data-text="$t('form.dropdown_not_found')"
                item-color="#ffff00"
                :search-input.sync="searchQuery"
                v-model="select"
                :loading="isLoading"
                return-object
                hide-details
                append-icon="mdi-chevron-down"
        />

        <Validation
            v-if="v && v.$dirty"
            :v="v"
        />
    </div>
</template>

<script>
    import { getLocationSuggestions } from "@/api/clientServices";
    import { debounce } from '@/helpers/debounce'
    import Validation from "./Validation";

    export default {
        components: {
            Validation
        },

        props: {
            placeholder: {
                type: String,
                required: true,
            },
            list: {
                type: Array,
                required: false,
            },
            v: {
                type: Object,
                required: false,
            },
            isLocationSuggestions: {
                type: Boolean,
                required: false
            },
            isReset: {
                type: Boolean,
                required: false
            },
            theme: {
                type: String,
                default: 'light'
            }


        },

        data() {
            return {
                searchQuery: null,
                select: null,
                items: [],
                isLoading: false
            }
        },
        watch: {
            searchQuery(val) {
                if(this.isLocationSuggestions && val) {
                    this.debounceLoading()
                }
            },
            isReset(val) {
                if(val) this.resetHandler()
            }
        },

        methods: {
            resetHandler() {
                this.$nextTick(() => {
                    this.searchQuery = '';
                    this.select = null;
                });
            },
            changeHandler(val) {
                this.$emit('update', val);
                if (this.v) this.v.$touch();
            },
            async getLocationSuggestion(){
                this.isLoading = true;
                try {
                    let response = await getLocationSuggestions(this.searchQuery)
                    this.items = response.data.data.suggestions;
                    this.isLoading = false;
                } catch(e) {
                    this.isLoading = false;
                    console.log(e)
                }
            },
        },
        computed: {
            debounceLoading() {
                let delay = 300;
                return debounce(this.getLocationSuggestion, delay)
            },
            currentList() {
                let current = !this.isLocationSuggestions ? this.list : this.items
                return current;
            },
        },
    }
</script>

<style lang="sass" scoped>
    .autocomplete
        cursor: pointer
        &::v-deep
            .v-select__slot
                input,
                textarea
                    +reg
                    font-size: 14px
                    color: $color--white

            .v-input
                &__slot
                    border: 1px solid transparent
                    border-radius: 2px
                    margin-bottom: 0
                    background: transparent
                    transition: background .3s ease, border-color .3s ease
                    &::after, &::before
                        border-color: transparent!important
                        border-style: none!important
                        border-width: 0!important
                &__append-inner
                    margin-right: 22px
                    margin-top: 0
                &__icon
                    position: absolute
                    top: 50%
                    transform: translateY(-50%) rotate(45deg)
                    display: inline-block
                    border-right: 1px solid #99A8B8
                    border-bottom: 1px solid #99A8B8
                    width: 6.5px
                    height: 6.5px
                    min-width: auto
                    transition: transform .3s ease, border-color .3s ease
            .v-icon
                display: none
        &.v-select--is-menu-active
            &::v-deep
                .v-input__icon
                    border-color: #6D7B93
                    transform: rotate(225deg)
        &.light
            &::v-deep
                .v-input__slot
                    border-color: rgba(11, 35, 75, 0.15)
                    &:hover
                        background:  #FCFDFF
                        border-color: rgba(#0B234B, 0.25)
                    input
                        color: $color--dark
        &.light.v-input--is-label-active,
        &.light.v-input--is-focused
            &::v-deep
                .v-input__slot
                    border-color: rgba(#0B234B, 0.25)
        &.dark
            &::v-deep
                .v-input__slot
                    border-color: #3C4F6F
                    color: #fff
                    background: #0B234B
                    &:hover
                        background: #122A50
                        border-color: $input-border--hover
                .v-select__slot
                    input
                        &::placeholder
                            color: rgba($color--white, 0.5)
                .v-icon
                    color: #99A8B8
        &.dark.v-input--is-label-active,
        &.dark.v-input--is-focused
            &::v-deep
                .v-input__slot
                    background: #0C244C
                    border-color: $input-border--active




</style>

